import { useState, useEffect } from 'react';
import { get } from '../../../../components/hooks/apiFetch';

export const useDefaultPermissions = () => {
    const [defaultPermissions, setDefaultPermissions] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchDefaultPermissions = async () => {
        setLoading(true);
        setError(null);
        try {
            const permissions = await get('/api/TaskFileAccess/GetDefaultPermissionsForAllRoles');
            setDefaultPermissions(permissions);
        } catch (err) {
            console.error('Ошибка загрузки дефолтных прав:', err);
            setError(err.message);

            setDefaultPermissions(getHardcodedDefaultPermissions());
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDefaultPermissions();
    }, []);

    const getDefaultPermissionsForRole = (role) => {
        return defaultPermissions[role] || getHardcodedDefaultPermissions()[role];
    };

    return {
        defaultPermissions,
        getDefaultPermissionsForRole,
        loading,
        error,
        refetch: fetchDefaultPermissions
    };
};

const getHardcodedDefaultPermissions = () => ({
    Viewer: {
        canRead: true,
        canEdit: false,
        canDeleteOwnVersions: false,
        canDeleteAllVersions: false
    },
    Editor: {
        canRead: true,
        canEdit: true,
        canDeleteOwnVersions: true,
        canDeleteAllVersions: false
    },
    Admin: {
        canRead: true,
        canEdit: true,
        canDeleteOwnVersions: true,
        canDeleteAllVersions: true
    },
    Creator: {
        canRead: true,
        canEdit: true,
        canDeleteOwnVersions: true,
        canDeleteAllVersions: true
    }
});